import React from 'react';
import { Button, CircularProgress, styled } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';

interface NextButtonProps extends ButtonProps {
  disabled: boolean;
  buttonName?: string | undefined;
  sx?: object;
  isLoading?: boolean;
  newUI?: boolean
}

const StyledButton = styled(Button)<NextButtonProps>(({ disabled }) => ({
  cursor: disabled ? 'not-allowed' : 'pointer',
  transition: 'opacity 0.3s ease'
}));

const NextButton: React.FC<NextButtonProps> = ({ disabled, onClick, buttonName = 'Next', isLoading = false, sx, newUI = true }) => {


  return (
    <StyledButton
      size="large"
      variant="contained"
      fullWidth
      onClick={onClick}
      data-cy="next-button"
      disabled={disabled}
      sx={{
        background: !newUI ? ' ' : 'linear-gradient(176.8deg,rgba(12, 175, 207, 0.69) 0%,rgba(89, 15, 107, 0.99) 99% )',
        color: !newUI ? 'black' : 'white',
        borderRadius: 50,
        marginTop: 6,
        fontWeight: 'bold',
        '&:hover': {
          background: !newUI ? ' ' : 'linear-gradient(176.8deg,rgba(12, 175, 207, 0.69) 0%,rgba(89, 15, 107, 0.99) 99% )'
        },
        '&.Mui-disabled': {
          cursor: 'not-allowed',
          pointerEvents: 'auto',

          ...sx
        }
      }}
    >
      {isLoading && <CircularProgress className='mr-4' size={16} />}
      {buttonName}
    </StyledButton>
  );
};

export default NextButton;
